import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
export default {
  name: "popBioMatrixScanReward",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting']),
    ...userVuex.mapState(["userData", "inviter"])
  },
  data() {
    return {};
  },
  props: {
    taskInfo: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    "$parent.popBioMatrixScanRewardShow": {
      handler(newVal, oldVal) {
        if (!newVal && typeof oldVal !== 'undefined') {
          this.$parent.popBioMatrixScanRewardShow = false;
          //cookie.set("advTip:"+this.userData.id+":"+this.setting.popadv.id,true, { expires: 1/this.setting.popadv.pop_times })
        }
      },

      deep: true,
      immediate: true
    }
  },
  methods: {
    async onSubmit() {
      this.$parent.popBioMatrixScanRewardShow = false;
      this.$nextTick(() => {
        this.$parent.popBioMatrixScanCheckShow = true;
      });
    }
  }
};